export enum BmarkSummaryViewFilterType {
  /**
   * BmarkSummaryViewFilterType.All is the same as having no view filter.
   **/
  ALL,
  ACTIVE,
  FILLED,
}
